import { Navigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";

export default function ProtectedAdmin({ children }) {
  const { user } = useAuth();
  if (user === null) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--bg)]">
        <div className="font-mono-ui text-xs tracking-[0.3em] uppercase text-[var(--text-2)]">
          Authenticating...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/admin/login" replace />;
  return children;
}
